import { render, staticRenderFns } from "./Centers.vue?vue&type=template&id=80bf32a8&scoped=true&"
import script from "./Centers.vue?vue&type=script&lang=js&"
export * from "./Centers.vue?vue&type=script&lang=js&"
import style0 from "./Centers.vue?vue&type=style&index=0&id=80bf32a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf32a8",
  null
  
)

export default component.exports